// extracted by mini-css-extract-plugin
module.exports = {"container":"DonutChart_container__1EZUO","subTitle":"DonutChart_subTitle__2cLO_","legends":"DonutChart_legends__2HmtV"};